import "../styles/herosection.css";
import resumePdf from "../assets/docs/Sailesh_Kafle_Resume.pdf";

const HeroSection = () => {
  return (
    <section id="home" className="hero-about-section">
      <div className="about-card">
        {/* Personal Badge */}
        <span className="badge">Open to Work</span>

        {/* Section Heading */}
        <h2>
          <span className="wave-emoji">👋</span> Hey, I'm Sailesh!
        </h2>

        {/* Main About Paragraphs */}
        <p>
          I’m a software developer and AI engineer with a Master’s in Computer
          Science. I build full-stack web applications and design AI systems
          from training deep learning models to engineering LLM-powered tools
          that solve real-world problems.
        </p>
        <p>
          My research centers on AI for Software Engineering, including a novel
          LLM pipeline for automated commit message generation. I move
          comfortably across the stack shipping production apps with React and
          Node.js, and building with PyTorch, LangChain, Spark, and Docker.
        </p>
        <p>
          Feel free to{" "}
          <a href="mailto:saileshkafle47@gmail.com" className="inline-link">
            <span data-text="Contact Me">Contact Me</span>
          </a>{" "}
          or check out my{" "}
          <a
            href={resumePdf}
            className="inline-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span data-text="Resume">Resume</span>
          </a>{" "}
          to learn more.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
